import document from 'global/document';
import videojs from 'video.js';

const Button = videojs.getComponent('Button');

/**
 * A video.js Component for the 'next item' button
 */
export default class Tile extends Button {
  constructor(player, options) {
    super(player, options);

    this.index = options.index;
    this.title = options.title;
  }

  createEl() {
    const el = document.createElement('div');
    el.className = 'vjs-video-tile';

    const tileEl = document.createElement('img');
    tileEl.className = 'vjs-video-tile-img';

    const { title, thumbnail } = this.options_;
    tileEl.src = thumbnail;

    const descriptionEl = document.createElement('p');
    descriptionEl.className = 'vjs-video-tile-description';
    descriptionEl.innerHTML = title;

    el.appendChild(tileEl);
    el.appendChild(descriptionEl);

    return el;
  }

  handleClick() {
    this.player_.trigger('controls:overlay:close');
    this.player_.playlist.advanceTo(this.index);
  }
}



// WEBPACK FOOTER //
// ./node_modules/video-js-core/src/playlistControls/overlay/Tile.js